import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

export default function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { signIn } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const { error } = await signIn(email, password);

    if (error) {
      setError('登入失敗，請檢查您的電子郵件和密碼');
      setLoading(false);
    } else {
      // 根據郵件地址決定跳轉頁面
      if (email === 'yirun0206@gmail.com') {
        navigate('/admin/dashboard');
      } else {
        navigate('/creator/dashboard');
      }
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-900 via-slate-800 to-slate-900 flex items-center justify-center px-6 py-12">
      <div className="max-w-md w-full">
        <div className="text-center mb-8">
          <Link to="/">
            <img 
              src="https://public.readdy.ai/ai/img_res/43e5ec71-732c-47e6-8652-53c813fd533d.png"
              alt="Logo"
              className="h-16 mx-auto mb-6"
            />
          </Link>
          <h1 className="text-3xl font-bold text-white mb-2">登入</h1>
          <p className="text-slate-400">登入您的帳號</p>
        </div>

        <div className="bg-slate-800/80 rounded-xl p-8 border border-slate-700">
          <form onSubmit={handleSubmit} className="space-y-6">
            {error && (
              <div className="bg-red-500/20 border border-red-500/50 rounded-lg p-4 flex items-start">
                <i className="ri-error-warning-line text-xl text-red-400 mr-3 mt-0.5"></i>
                <p className="text-red-300 text-sm">{error}</p>
              </div>
            )}

            <div>
              <label htmlFor="email" className="block text-white font-medium mb-2 text-sm">
                電子郵件
              </label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="w-full px-4 py-3 bg-slate-900 border border-slate-600 rounded-lg text-white placeholder-slate-500 focus:outline-none focus:border-teal-500 transition-colors text-sm"
                placeholder="your@email.com"
              />
            </div>

            <div>
              <label htmlFor="password" className="block text-white font-medium mb-2 text-sm">
                密碼
              </label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="w-full px-4 py-3 bg-slate-900 border border-slate-600 rounded-lg text-white placeholder-slate-500 focus:outline-none focus:border-teal-500 transition-colors text-sm"
                placeholder="••••••••"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-teal-500 hover:bg-teal-600 disabled:bg-slate-600 text-white py-3 rounded-lg font-medium transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer disabled:cursor-not-allowed"
            >
              {loading ? '登入中...' : '登入'}
            </button>
          </form>

          <div className="mt-6 pt-6 border-t border-slate-700 text-center">
            <Link to="/" className="text-slate-400 hover:text-teal-400 text-sm transition-colors cursor-pointer whitespace-nowrap">
              <i className="ri-arrow-left-line mr-1"></i>
              返回首頁
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
